var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6229 8.54006C17.6229 10.098 17.004 11.5922 15.9023 12.6938C14.8007 13.7954 13.3065 14.4143 11.7486 14.4143C10.1906 14.4143 8.69647 13.7954 7.59483 12.6938C6.49318 11.5922 5.87429 10.098 5.87429 8.54006C5.87429 6.9821 6.49318 5.48795 7.59483 4.38631C8.69647 3.28467 10.1906 2.66577 11.7486 2.66577C13.3065 2.66577 14.8007 3.28467 15.9023 4.38631C17.004 5.48795 17.6229 6.9821 17.6229 8.54006ZM0 24.2048C0 26.1629 1.9581 26.1629 1.9581 26.1629H21.5391C21.5391 26.1629 23.4971 26.1629 23.4971 24.2048C23.4971 22.2467 21.5391 16.3724 11.7486 16.3724C1.9581 16.3724 0 22.2467 0 24.2048ZM26.4343 8.36383C29.1502 5.57354 35.9408 10.459 26.4343 16.7386C16.9297 10.459 23.7184 5.57158 26.4343 8.36383Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9896,
    height: 31.9896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/Client.04438158ca4663c7100e538f1d7a74a3.svg";
export { ForwardRef as ReactComponent };